// Phone-number check for forms. Mirrors the server rules in
// api/src/utils/phone.py so a typo is caught before the request; the server
// stays the authority and normalizes what it stores.
//
// Accepts digits with spaces, dots, dashes and parentheses. A 10-digit
// North American number (optionally led by 1 or +1) is fine; anything else
// needs a leading + and 8-15 digits.

// Longest accepted input, measured on the trimmed text exactly as the server
// does (api/src/utils/phone.py _MAX_INPUT_LEN).
export const PHONE_MAX_LENGTH = 40

export const PHONE_INVALID_MESSAGE =
  'Enter a valid phone number, like (555) 123-4567, or include a country code like +44 20 7946 0958.'

/** True for blank (optional) or a number the server will accept. */
export function isValidPhone(raw) {
  const text = String(raw ?? '').trim()
  if (!text) return true
  if (text.length > PHONE_MAX_LENGTH) return false
  if (!/^\+?[0-9 ().-]+$/.test(text)) return false
  let digits = text.replace(/\D/g, '')
  let plus = text.startsWith('+')
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1)
    plus = false
  }
  if (!plus && digits.length === 10) return true
  return plus && digits.length >= 8 && digits.length <= 15
}
